<template>
  <layout
    class="bg-white"
    :style="{
      'background-image': backgroundGradient
    }"
  >
    <content-scroll-container class="h-full">
      <content-scroll-inner class="h-full flex flex-col">
        <box-title-l :color="textColor" :lines="2">
          {{ $t("components.layouts.loading.title_1") }}<br />
          {{ $t("components.layouts.loading.title_2") }}
        </box-title-l>
        <div
          class="flex flex-grow items-center justify-center box-loading flex-col align-middle content-center"
        >
          <icon-loading-spinner :color="textColor" :progress="progress" />
        </div>
        <div
          class="flex-shrink-0 box-bottom flex flex-col justify-center align-middle content-center"
        >
          <p
            class="text-chplus-regular"
            :class="{
              'text-landingfade-dark': textColor == 'blue',
              'text-color-white': textColor == 'white'
            }"
          >
            {{ $t("components.layouts.loading.subtitle") }}
          </p>
        </div>
      </content-scroll-inner>
    </content-scroll-container>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/LayoutBase";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import BoxTitleL from "@/components/layouts/BoxTitleL";
import IconLoadingSpinner from "@/components/icons/IconLoadingSpinner";
import { mapGetters } from "vuex";

export default {
  name: "Loading",
  components: {
    Layout,
    IconLoadingSpinner,
    ContentScrollContainer,
    ContentScrollInner,
    BoxTitleL
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    textColor: {
      type: String,
      default: "blue",
      validator: function(value) {
        // The value must match one of these strings
        return ["white", "blue"].includes(value);
      }
    },
    progress: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("location", ["canton"]),
    backgroundGradient() {
      if (this.textColor == "white" && this.user && this.user.cantonId) {
        return this.canton(this.user.cantonId).backgroundGradient;
      }
      return "none";
    }
  }
};
</script>

<style scoped>
.box-bottom {
  height: 7rem;
}

@media (min-width: 768px) {
  .box-bottom {
    height: 8rem;
  }
}
</style>
